module.exports = __webpack_public_path__ + "static/media/doge.79eee322.png";